import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { getApi } from '../api'

/**
 * Removes a type from the vocabulary. The engine allows this even while trackers carry it — the
 * foreign key is `nullOnDelete`, so those trackers keep working and silently lose their type,
 * with nothing to restore it. Confirm before calling.
 */
export default () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ accountId, id }: { accountId: number; id: number }) => {
      const { api, baseURL } = getApi()
      return api.delete(
        `/api/v2/accounts/${accountId}/container-types/${id}`,
        { baseURL, allow404: true },
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account-container-types'] })
      queryClient.invalidateQueries({ queryKey: ['account-device'] })
    },
  })
}
